import builder from '../builder';
import AccountingCoinsBill from '../../streamline-icons/light/accounting-coins-bill.svg';

export default builder('IconAccountingCoinsBillLight', AccountingCoinsBill);
